import { render, staticRenderFns } from "./photoContest.vue?vue&type=template&id=5c9b0604&scoped=true"
import script from "./photoContest.vue?vue&type=script&lang=js"
export * from "./photoContest.vue?vue&type=script&lang=js"
import style0 from "./photoContest.vue?vue&type=style&index=0&id=5c9b0604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b0604",
  null
  
)

export default component.exports